module.exports = __webpack_public_path__ + "assets/sushi_active-eb67d9.svg";